import * as React from 'react';
import { Typography } from 'ui';
import s from './Title.module.scss';

interface TitleProps {
  bgTitle: string;
  title: string;
}

export const Title: React.FunctionComponent<TitleProps> = ({
  bgTitle,
  title,
}) => {
  return (
    <div className={s.root}>
      <p className={s.bgTitle}>{bgTitle}</p>
      <Typography
        variant="large_title"
        color="text_default"
        label={title}
        className={s.title}
      />
    </div>
  );
};
